import Vue from 'vue'
import { Message } from 'element-ui'
const bus = new Vue()
window.bus = bus
const commonFn = {
  toastMsg(type, msg) {
    switch (type) {
    case 'normal':
      Message(msg)
      break
    case 'success':
      Message({
        message: msg,
        type: 'success',
        customClass: 'highest'
      })
      break
    case 'warning':
      Message({
        message: msg,
        type: 'warning',
        customClass: 'highest'
      })
      break
    case 'error':
      Message({
        message: msg,
        type: 'error',
        customClass: 'highest'
      })
      break
    case 'href':
      let newMessage = Message({
        dangerouslyUseHTMLString: true,
        type: 'warning',
        duration: 30000,
        message: '正在生成文件，<a class="clickHere" href="/home/export-data?type=customer" @click="toExport">点击此处</a>前往导出列表下载',
        customClass: 'highest href'
      })
      newMessage.$el.querySelector('a').onclick = () => {
        sessionStorage.setItem('leftPath', '/home/export-data?type=customer')
      }
      break
    case 'href1':
      let newMessage1 = Message({
        dangerouslyUseHTMLString: true,
        type: 'warning',
        duration: 30000,
        message: '正在生成文件，<a class="clickHere" href="/home/export-data-order?type=order" @click="toExport">点击此处</a>前往导出列表下载',
        customClass: 'highest href'
      })
      newMessage1.$el.querySelector('a').onclick = () => {
        sessionStorage.setItem('leftPath', '/home/export-data-order?type=order')
      }
      break
    }
  },

  getCondition(searchObj) {
    let deleteField = [
      'relationOptions',
      'activitiesTwo',
      'templatesTwo',
      'wepageTwo',
      'qrcodeOptions',
      'templateOption',
      'relationOptions',
      'optionOther',
      'option'
    ]
    let condition = JSON.parse(JSON.stringify(searchObj))
    for (let i in condition['termsGroup']) {
      for (let ti in condition['termsGroup'][i]['terms']) {
        for (let delfield of deleteField) {
          delete delete condition['termsGroup'][i]['terms'][ti][delfield]
        }
      }
    }
    return condition
  }

}
export default commonFn
